export function apiConexion(opt, url, type, tpsend, cb){     
    let _URL        = tpsend == 1 ? '/send/' : url,
        _CROSDOMAIN = tpsend != 1,
        _DATATYPE   = tpsend == 1 ? 'json' : 'jsonp',
        _TYPE       = tpsend == 1 ? 'POST' : type

    if(tpsend == 1){
        opt.__type = type;
        opt.__url = url;
    }

    $.ajax({ 
        type        : _TYPE,
        url         : _URL,
        dataType    : _DATATYPE,
        data        : opt,
        cache       : false,
        crossDomain : _CROSDOMAIN,
        success: function(data,status,xhr){
            if(typeof cb == 'function') cb(data);
        },
        error: function(data, status, e){            
            console.log(data.responseText);
        }
    });
}

export function round_number(numero,decim){
    let res = Math.pow(10, decim);
    return (Math.round(numero * res) / res);
}

export function addCurrency(conv, pref, num_str, decim, pegado = false){
    let numero = Number(num_str)
    if(decim == undefined) decim = 0;
    numero  = round_number(numero * conv, decim);
    let numeroSTR = numero.formatMoney(decim, ',', '.')
    return (pref + (pegado ? '&nbsp;' : ' ') + numeroSTR);
}

export function setYearDiff(YearF,YearI){
    var AnioF=YearF.getYear()
    ,   AnioI=YearI.getYear()
    ,   rta=AnioF-AnioI
    ,   MesF=YearF.getMonth()
    ,   MesI=YearI.getMonth()
    ,   DiaF=YearF.getDate()
    ,   DiaI=YearI.getDate()

    if((MesI>MesF)||(MesI==MesF&&DiaI>DiaF))   rta=rta-1;
    return rta
}

export function escapeHtml(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };

  return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}

export function dateFormat(date){
    let text_array = date.split('/');
    return text_array[2] + '/' + text_array[1] + '/' + text_array[0];
}
export function jSONInfo(config,option,callBack){
    let cnfAjax={
            url:config.dir
        ,   type:config.type
        ,   data: option
        ,   dataType:"json"
        ,   success: function(data) {           
                if(typeof callBack == 'function') callBack(data);
            }
        ,   error: function (data, status, e){
                console.log("jSONInfo - No se pudo cargar la pagina: ",data.responseText);
            }
        }
    ,   $files=config.Files
    if($files!=undefined&&$files.length!=0){       
        cnfAjax.fileElementId=$files;
        $.ajaxFileUpload(cnfAjax);
    }
    else{
         $.ajax(cnfAjax);
    } 
}

export function printMessages(data, id_form, cerrar){
    const $form     = $('#'+ id_form),
          $ctm_msg  = $form.find('.ctm_msg'),
          status    = data.status

    if($ctm_msg.is(':visible')) $ctm_msg.slideUp('fast')

    $ctm_msg.text( findText(data.mensaje) )
    $ctm_msg.removeClass('err succ')
            .addClass(data.status.error ? 'err' : 'succ')

    $ctm_msg.slideDown('fast');
    setTimeout( () => { 
        $ctm_msg.slideUp('fast');

        if(status.close && typeof cerrar == 'function'){
            cerrar()
        }

        if(status.reload){
            window.location.reload() 
        }

        if(status.go){
            window.location.href=status.go
        }

        if(status.go_to){
            window.location.href=status.go_to
        }

    }, status.error ? 9000 : 5000)
}

export function afterSubmit(data, id_form, cerrar){
    let status      = data.status
    ,   mensaje     = data.mensaje
    if(!status.error){
        $('#' + id_form)[0].reset()
    }
    printMessages(data, id_form, cerrar);
}

export function checkMessages(app, text, title = null, buttons = null){
    if(text == '') return false;

    title       = title == null ? x_textos['550-0'] : title
    buttons     = buttons == null ? [{ text: x_textos['R256-0'], onClick: function(){ app.dialog.close() }}] : buttons

    return  app.dialog.create({
                title:      title, 
                text:       text,
                buttons:    buttons 
            }).open() 
}

function printMessagesMovil(app, data, id_form, cerrar){
    const   $form     = $('#'+ id_form),
            status    = data.status,
            $button     = [{ text: x_textos['R256-0'], onClick: function(){ 

                if(status.close && typeof cerrar == 'function'){
                    cerrar()
                }

                if(status.reload){
                    window.location.reload() 
                }

                if(status.go){
                    window.location.href=status.go
                }

                if(status.go_to){
                    window.location.href=status.go_to
                }
                app.dialog.close()               
            }}]
    checkMessages(app, findText(data.mensaje), x_textos['550-0'], $button)  
}

export function afterSubmitMovil(app, data, id_form, cerrar){
    let status      = data.status
    ,   mensaje     = data.mensaje
    console.log(data)
    if(!status.error){
        $('#' + id_form)[0].reset()
    }
    printMessagesMovil(app, data, id_form, cerrar);
}

export function getUserinfo(){
    if (window.localStorage){
        if(window.localStorage.getItem('_user')==null){
            return {status:false}
        }
        else{
            let _user=JSON.parse(window.localStorage.getItem('_user'))
            _user.status=true
            return _user
        }
    }
    return {status: false}
}
export function form_bloq(bloquear){
    var $InputType=$('input, textarea, select')
    ,   $Buttons=$('button:not([data-disabled="force"])')
    if(bloquear){
        $InputType.prop("readonly", true);
        $Buttons.prop("disabled", true);
    }
    else{
        $InputType.prop("readonly", false);
        $Buttons.prop("disabled", false);
    }  
}

export function statusGoogle(){
    if(typeof google !== "undefined"){
        return true;
    }
    else{
        console.log('Revisando Google')
        setTimeout(statusGoogle, 50);
    }
}

export function niceStrUnion(arraySTR, upperCase){
    let cant       =arraySTR.length
    if(cant==0)    
        return  '';
    else if(cant==1)    
        return  upperCase ? capitalizeFirstLetter(arraySTR[0]) : arraySTR[0]
    else{
        let rtaToShow  = upperCase ? capitalizeFirstLetter(arraySTR.join(', ')) : arraySTR.join(', ')
        ,   lenLast    = arraySTR[cant-1].length + 2
        return      rtaToShow.substr(0, rtaToShow.length-lenLast) + ' ' + findText('txt-M587-1') + ' ' + arraySTR[cant-1]
    }
}
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function getGeodecoder(dir_to_geo, callback){
    let geocoder = new google.maps.Geocoder()
    geocoder.geocode({"address":dir_to_geo }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            var lat = results[0].geometry.location.lat(),
                lng = results[0].geometry.location.lng(),
                placeName = results[0].formatted_address;

            if(callback != undefined){
                callback(true, lat, lng, placeName)
            }
            
        }
        else{
            if(callback != undefined){
                callback(false)
            }
        }
    });
}

function setErrorAutocomplete($input, active){
    let $error = $input.parents('.datos-domicilio').find('.error')
    if($error.length){
        $error.remove()
        $input.removeClass('invalid')
    }
    $input.parent().append('<span class="error">'+ x_textos["570-0"] +'</span>')
    $input.addClass('invalid')
}

function getLatLng($input, id_input, lat, lng, calculos){
    let $error = $input.parents('.datos-domicilio').find('.error')

    if($error.length){
        $error.remove()
        $input.removeClass('invalid')
    }

    let recogida = id_input === 'dir-origen' ? 1 : 0,
        entrega = id_input === 'dir-recogida' ? 1 : 0,
        cod_search = $('#cod-search').val()

    if(recogida || entrega){
        let opts = {
                cod      : cod_search,
                recogida : recogida,
                entrega  : entrega,
                latDomi  : lat,
                lngDomi  : lng,
                dirDomi  : $input.val() 
            }
        $input.attr({'data-lat':lat,'data-lng':lng})
        jSONInfo({dir:'/action/getDelivery/',type:'POST'},opts,function(data){ 
            let $reserva=$('#reserva') 
            ,   ans     = data.ans
            ,   dataName=recogida?'cost_min_domi_i':(entrega?'cost_min_domi_f':'')
            ,   costo=ans.costo

            if(ans.status){
                $reserva.attr('data-'+dataName,costo)   
                calculos.showAllData()  

            }else{
                $input.parent().append('<span class="error">'+ ans.err +'</span>')
                $input.addClass('invalid')
            }
        })
    }
}

export function putLoadingInSelect(select_id){
    let $select = $('#' + select_id)
    ,   $input  = $select.parents('.select-wrapper').first().find('input.select-dropdown')
    ,   $caret  = $input.prev()
    $caret.html("&#xF110")
    $caret.css({'animation' : 'fa-spin 2s infinite linear'})
}

export function removeLoadingInSelect(select_id){
    let $select = $('#' + select_id)
    ,   $input  = $select.parents('.select-wrapper').first().find('input.select-dropdown')
    ,   $caret  = $input.prev()
    $caret.html("&#xF107")
    $caret.css({'animation' : 'unset'})
}

export function linebrakeInSelect(select_id){
    let $select     = $('#' + select_id)
    ,   $option    = $select.find('option')
    ,   $li         = $select.parents('.select-wrapper').first().find('li')
    $li.each(function(index,data){
        let text        = $(this).text()
        ,   text_array  = text.split(' - ')
        ,   count       = text_array.length
        ,   g_class     = $($option.get(index)).attr('class')
        g_class = g_class == undefined ? 'normal' : g_class
        $(this).html('')
        $(this).addClass(g_class)
        for(let i in text_array){
            $(this).append( '<span class="select_li_' + i + '">' 
                        +       text_array[i] 
                        +   '</span>'  + (count > (i+1) ? '<span style="display:none"> - </span>' : ''))
        }
    })
}

export function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    str = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    str = str.replace(/([^>\t]?)(\t)/g, '$1' + ' ' + '$2')
    return str;
}

export function printButtons(btn){
    let print   = '';
    for(let i in btn){
        // let action = btn[i].action == undefined ? 'confirm' : btn[i].action
        print   = print + '<a class="remodal-confirm" href="' + btn[i].intLink + '">' + findText(btn[i].title) + '</a>'
    }
    return print
}

export function getAttrs(div, withoutData = true){
    if(div[0]!=undefined){
        var attrs = div[0].attributes;
        var Opciones={};            
        for(var i=0;i<attrs.length;i++){
            if(attrs[i].nodeName.substr(0,4)=="data"){
                var Propiedad=(withoutData ? attrs[i].nodeName.substr(5) : attrs[i].nodeName);          
                Opciones[Propiedad]=attrs[i].value;
            }
        }
        return Opciones;
    }
}

export function getPartnerId(){
    let urlParams = $.parseParams(window.location.search)
    if(typeof urlParams == 'undefined') return '';
    if(urlParams.partnerId != undefined)    return '?partnerId=' + urlParams.partnerId
    return '';
}

export function changeValue($c, val){
    $c.val(val)
    $c.parents('.smart-select').find('.item-after').text($c.find('[value="' + val + '"]').text())
}

export function checkInput(type) {
    var input = document.createElement("input");
    input.setAttribute("type", type);
    return input.type == type;
}

export function sendIALQ(dataForm, tiempo){
    if(tiempo === 0){
        $.ajax({url: '/action/ialq/',type: 'POST', data: dataForm});
        return false
    }
    else{
        return  setTimeout(function(){
            $.ajax({url: '/action/ialq/',type: 'POST', data: dataForm});
        }, tiempo);
    }
}

